import { Accordion } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as RootStyled from '../../styled';
import dogs from '../assets/dogs.webp';
import paw from '../assets/paw.png';
import * as Styled from './styled';

type Item = {
  question: string;
  answer: string;
};

export const QuestionsSection: FC = () => {
  const { translate } = useTranslation({ keyPrefix: 'breederLanding.questions' });
  const items: { [key: string]: Item } = translate('items', { returnObjects: true }) ?? {};

  return (
    <Styled.Container>
      <div>
        <RootStyled.Title color="light">{translate('title')}</RootStyled.Title>
        <RootStyled.Paragraph>{translate('text')}</RootStyled.Paragraph>
      </div>

      <Accordion
        tabs={Object.entries(items).map(([, value]) => {
          return {
            title: value.question,
            content: <Styled.AccordionContent>{value.answer}</Styled.AccordionContent>,
          };
        })}
      />

      <Styled.DogsImage>
        <img src={dogs} alt="" width="100%" />
      </Styled.DogsImage>

      <Styled.PawsImage>
        <img src={paw} alt="" width="100%" />
      </Styled.PawsImage>
    </Styled.Container>
  );
};
